export const MEWS_COMMUNITY_WEIGHT = 10;

export const mewsCommunityUrl = 'https://community.mews.com/';
